"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleInfoService = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable class-methods-use-this */
var conversions_1 = require("@dtna/dvs-core-dcp-client-utils/lib/utils/conversions");
var browserStorage_1 = require("@dtna/dvs-core-dcp-client-utils/lib/utils/browserStorage");
var vehicleInfo_slice_1 = require("../slices/vehicleInfo.slice");
var vehicleInfo_1 = require("../utils/vehicleInfo");
var user_selector_1 = require("../selectors/user.selector");
var user_model_1 = require("../models/user.model");
var proxyApi_1 = require("../constants/proxyApi");
var ProxyApi_1 = __importDefault(require("../services/ProxyApi"));
var VehicleInfoService = /** @class */ (function () {
    function VehicleInfoService() {
        var _this = this;
        this.getVehicleInfoForVinPromise = function (vin) { return __awaiter(_this, void 0, void 0, function () {
            var tan, url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tan = (0, browserStorage_1.getTan)();
                        url = "".concat(proxyApi_1.BASE_URL).concat(proxyApi_1.PROXY_API.GET.VEHICLE_INFO.replace(/:tan/, tan).replace(/:vin/, vin));
                        return [4 /*yield*/, ProxyApi_1.default.protectedRequest({ url: url })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        this.getAndParseVehicleInfoForVinPromise = function (vin, unitSystemType) { return __awaiter(_this, void 0, void 0, function () {
            var data, metric, imperial;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVehicleInfoForVinPromise(vin)];
                    case 1:
                        data = _a.sent();
                        metric = unitSystemType === user_model_1.UNITS_SYSTEM_TYPES.METRIC;
                        imperial = unitSystemType === user_model_1.UNITS_SYSTEM_TYPES.IMPERIAL;
                        if (data.odometer) {
                            data.odometer = Math.round(metric ? (0, conversions_1.milesToKilometers)(data.odometer) : data.odometer);
                        }
                        if (data.batteryRange) {
                            data.batteryRange = Math.round(imperial ? (0, conversions_1.kilometersToMiles)(data.batteryRange) : data.batteryRange);
                        }
                        return [2 /*return*/, data];
                }
            });
        }); };
        this.handleRequestVehicleRow = function (api) { return __awaiter(_this, void 0, void 0, function () {
            var state, vehicleInfo, unitsSystemType, currentVin, vehicleInfoes, _a, vin, unitId, response, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        state = api.getState();
                        vehicleInfo = state.vehicleInfo;
                        unitsSystemType = user_selector_1.UserAccessors.getUserUnitsSystemType(state);
                        currentVin = vehicleInfo.currentVin, vehicleInfoes = vehicleInfo.vehicleInfoes;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 5, , 6]);
                        if (!(currentVin && vehicleInfoes && currentVin in vehicleInfoes)) return [3 /*break*/, 3];
                        _a = vehicleInfoes[currentVin], vin = _a.vin, unitId = _a.unitId;
                        return [4 /*yield*/, (0, vehicleInfo_1.fetchVehicleRow)(vin, (0, conversions_1.deriveSerialFromVin)(vin), unitId)];
                    case 2:
                        response = _c.sent();
                        if (response && user_model_1.UNITS_SYSTEM_TYPES.METRIC === unitsSystemType) {
                            response = (0, vehicleInfo_1.convertVehicleListDataToMetric)([response]).shift();
                        }
                        api.dispatch({ type: vehicleInfo_slice_1.VEHICLE_INFO_RECEIVE_VEHICLE_DATA, payload: response });
                        return [3 /*break*/, 4];
                    case 3: throw new Error();
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        _b = _c.sent();
                        api.dispatch({ type: vehicleInfo_slice_1.VEHICLE_INFO_ERROR_VEHICLE_DATA });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        this.handleNeedsDataAction = function (api) { return function (action) { return __awaiter(_this, void 0, void 0, function () {
            var vin, unitSystemType;
            return __generator(this, function (_a) {
                vin = action.payload;
                unitSystemType = user_selector_1.UserAccessors.getUserUnitsSystemType(api.getState());
                if (vin) {
                    this.getAndParseVehicleInfoForVinPromise(vin, unitSystemType)
                        .then(function (vehicleInfoResponse) { return api.dispatch({ type: vehicleInfo_slice_1.VEHICLE_INFO_GOT_DATA_ACTION, payload: { vin: vin, vehicleInfo: vehicleInfoResponse } }); })
                        .catch(function (error) { return api.dispatch({ type: vehicleInfo_slice_1.VEHICLE_INFO_GOT_ERROR_ACTION, payload: { vin: vin, error: error } }); });
                }
                else {
                    api.dispatch({ type: vehicleInfo_slice_1.VEHICLE_INFO_GOT_ERROR_ACTION, payload: { vin: vin, error: 'No VIN present in payload, somehow...' } });
                }
                return [2 /*return*/];
            });
        }); }; };
        this.getVehicleListPromise = function (query) { return __awaiter(_this, void 0, void 0, function () {
            var tan, url;
            return __generator(this, function (_a) {
                tan = (0, browserStorage_1.getTan)();
                url = "".concat(proxyApi_1.BASE_URL).concat(proxyApi_1.PROXY_API.GET.VEHICLES_LIST_PAGE_TAN.replace(':tan', tan));
                return [2 /*return*/, ProxyApi_1.default.protectedRequest({
                        url: url,
                        params: query,
                    })];
            });
        }); };
    }
    return VehicleInfoService;
}());
exports.VehicleInfoService = VehicleInfoService;
var service = new VehicleInfoService();
exports.default = service;
